import React, { Fragment } from "react";

const STEPS = [
  { key: "cart", label: "Cart" },
  { key: "checkout", label: "Delivery & payment" },
  { key: "done", label: "Confirmation" },
];

const Tick = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="M4 10.5 8 14.5 16 6" />
  </svg>
);

const CheckoutSteps = ({ current }) => {
  const activeIndex = STEPS.findIndex((step) => step.key === current);

  return (
    <div className="sy-steps-bar">
      <ol className="sy-steps" aria-label="Checkout progress">
        {STEPS.map((step, index) => {
          const done = index < activeIndex;
          const isCurrent = index === activeIndex;

          return (
            <Fragment key={step.key}>
              {index > 0 && <li className="sy-step-sep" aria-hidden="true" />}

              <li
                className={`sy-step${done ? " is-done" : ""}${isCurrent ? " is-current" : ""}`}
                aria-current={isCurrent ? "step" : undefined}
              >
                <span className="sy-step-dot">{done ? <Tick /> : index + 1}</span>
                <span className="sy-step-label">{step.label}</span>
              </li>
            </Fragment>
          );
        })}
      </ol>
    </div>
  );
};

export default CheckoutSteps;
